import React from "react";
import { useMediaQuery } from "@mui/system";
import { Grid } from "@mui/material";
import { FunctionField, Labeled, NumberField, ReferenceField, TextField } from "react-admin";
import { settings } from "app";
import { StaffRequestStatus } from "utils/choices";
import { administrationRequests } from "api/administrationApi";
import { employeeRequests } from "api/employeeApi";
import { SectionTitle } from "features/SectionTitle";

const ClassMakeUpsRequestsDetails = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <>
      <SectionTitle
        title="Данни за заявката"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Име">
            <FunctionField
              render={rec =>
                rec.studentSecondName
                  ? `${rec.studentFirstName} ${rec.studentSecondName} ${rec.studentLastName}`
                  : `${rec.studentFirstName} ${rec.studentLastName}`
              }
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Факултетен номер">
            <TextField source="studentFacultyNumber" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Курс">
            <NumberField source="studentCourse" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Специалност">
            <ReferenceField
              source="studentSpecialityId"
              reference={administrationRequests.getSpecialitiesSelect()}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Дисциплина">
            <ReferenceField
              source="disciplineId"
              reference={administrationRequests.getDisciplinesSelect()}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Тип занятие">
            <ReferenceField
              source="classTypeId"
              reference={administrationRequests.getRoomClassTypesSelect()}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Брой занятия">
            <NumberField source="classesCount" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Бележка">
            <TextField source="studentNote" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Създаден от">
            <ReferenceField
              source="staffRequest.createdByUserId"
              reference={employeeRequests.getEmployeesSelect()}
            >
              <FunctionField
                render={rec =>
                  rec.secondName
                    ? `${rec.firstName}  ${rec.secondName} ${rec.lastName}`
                    : `${rec.firstName} ${rec.lastName}`
                }
              />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Създаден на">
            <FunctionField
              render={rec =>
                rec?.staffRequest?.createdOn ? new Date(rec.staffRequest.createdOn).toLocaleString("bg-BG") : "-"
              }
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Статус">
            <FunctionField render={rec => StaffRequestStatus?.find(x => x.id === rec?.staffRequest?.status)?.name} />
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default ClassMakeUpsRequestsDetails;
